import React, { useRef, useState } from "react";
import useIntersectionObserver from "./hooks/useIntersectionObserver";
import "./style.css";

const About = () => {
  const sectionRef = useRef(null);
  const [contentLoaded, setContentLoaded] = useState(false);

  // Define a callback to be called when the element is intersected
  const handleIntersection = () => {
    setContentLoaded(true);
  };

  useIntersectionObserver(sectionRef, handleIntersection);

  const scrollToContact = () => {
    document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
  };

  // Enable the intersection observer
  useIntersectionObserver(sectionRef, handleIntersection);

  return (
    <div
      ref={sectionRef}
      className={`loading-container${
        contentLoaded ? "" : " loading-spinner-container"
      }`}
    >
      {contentLoaded ? (
        <section className="about" id="about">
          <figure className="about-banner">
            <img
              alt="Gonzalo de Salterain wearing a sleek white shirt with a thinking expression"
              className="w-100"
              src="./assets/images/gonzalo_hero2.png"
            />
            <div className="estrellas">
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
              <div className="lluvia_stars"></div>
            </div>
          </figure>
          <div className="about-content section-content">
            <p className="section-subtitle">About me</p>
            <h2 className="h3 section-title">
              Need Creative Solutions? I'm here to deliver Stars!
            </h2>
            <p className="section-text">
              I am Gonzalo de Salterain, an experienced creative manager and
              designer with a passion for crafting captivating content. I love
              building clean interfaces and turning concepts into functional
              designs. Whether working solo or with a team, I'm here to turn
              ideas into reality. Let's collaborate and make something
              extraordinary!
            </p>
            <div className="btn-group">
              <button
                className="btn btn-secondary"
                onClick={() => scrollToContact()}
              >
                Hire me
              </button>
              <a
                href="/assets/files/Resume-2023-GDS.pdf"
                download
                className="btn btn-primary"
              >
                Download cv
              </a>
            </div>
          </div>
        </section>
      ) : (
        <div className="observer_spinner" id="about"></div>
      )}
    </div>
  );
};

export default About;
